import { ChangeDetectorRef, Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  // tslint:disable-next-line:max-line-length
  selector: '[appHostReplace], app-aside, app-breadcrumbs, app-footer, app-header, app-sidebar, app-sidebar-footer, app-sidebar-form, app-sidebar-header, app-sidebar-minimizer, app-sidebar-nav, app-sidebar-nav-dropdown, app-sidebar-nav-item, app-sidebar-nav-link, app-sidebar-nav-title'
})
export class ReplaceDirective implements OnInit, OnDestroy {
  /** Nodi portati fuori dall'host al bootstrap (nodi statici e anchor dei blocchi @if/@for del template) */
  private moved: ChildNode[] = [];

  // Su un host di componente il ChangeDetectorRef e' la ViewRef del componente: `rootNodes`
  // elenca tutti i nodi che il suo template ha nel DOM, comprese le viste @if/@for create
  // DOPO lo spostamento (es. il <li> della voce di menu, creato dal primo change detection)
  constructor(private el: ElementRef, private viewRef: ChangeDetectorRef) { }

  // wait for the component to render completely
  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    let parentElement: HTMLElement;
    if(nativeElement.parentElement){
      parentElement= nativeElement.parentElement;
      // move all children out of the element
      while (nativeElement.firstChild) {
        this.moved.push(nativeElement.firstChild);
        parentElement.insertBefore(nativeElement.firstChild, nativeElement);
      }
      // remove the empty element(the host)
      parentElement.removeChild(nativeElement);
    }
      
  }

  // Quando la vista che contiene l'host viene distrutta (es. le voci del @for della sidebar,
  // ricreate a ogni menuChanged$), Angular toglie dal DOM solo l'host, che qui e' gia' staccato:
  // il contenuto renderizzato nel genitore resterebbe li'. Era il "menu raddoppiato" a ogni
  // salvataggio dell'organizzazione menu: i vecchi <li> restavano nella <ul> accanto ai nuovi.
  ngOnDestroy() {
    const rendered: ChildNode[] = (this.viewRef as unknown as { rootNodes?: ChildNode[] }).rootNodes || [];
    for (const node of new Set<ChildNode>([...rendered, ...this.moved])) {
      node.parentNode?.removeChild(node);
    }
    this.moved = [];
  }
}
